import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/markup-calculator',
  component: () => import('../../routes/MarkupCalculator.svelte'),
  card: {
    id: 'markup-calculator',
    title: 'Markup Calculator',
    description: 'Calculate selling price, profit, and gross margin from cost and markup percentage. See why markup ≠ margin with a conversion table.',
    icon: 'trending_up',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/markup-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Markup Calculator – Selling Price & Profit from Cost',
    description: 'Free markup calculator: enter cost and desired markup % to find selling price, profit, and gross margin. Includes markup-to-margin conversion table and common industry markups.',
  },
};

export default meta;
